var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20595 51.5H48.7537M26.4798 51.5V12.6111M26.4798 12.6111C29.5552 12.6111 32.0483 10.1238 32.0483 7.05556M26.4798 12.6111C23.4046 12.6111 20.9114 10.1238 20.9114 7.05556M32.0483 7.05556C32.0483 3.98731 29.5552 1.5 26.4798 1.5C23.4046 1.5 20.9114 3.98731 20.9114 7.05556M32.0483 7.05556H48.7537M20.9114 7.05556H4.20595M9.77443 40.3889C13.9857 40.3889 17.4691 38.0511 18.0439 34.1425C18.0803 33.8947 18.0986 33.7708 18.0843 33.4961C18.0745 33.3064 18.01 32.96 17.9511 32.7792C17.8657 32.5178 17.7621 32.3342 17.555 31.9667L9.77443 18.1667L1.99379 31.9667C1.80182 32.3072 1.70585 32.4775 1.61706 32.7733C1.56243 32.9553 1.4992 33.3919 1.50001 33.5817C1.50129 33.8906 1.52 33.9719 1.55747 34.135C2.26734 37.2222 5.67623 40.3889 9.77443 40.3889ZM43.1852 40.3889C47.3966 40.3889 50.88 38.0511 51.4547 34.1425C51.4911 33.8947 51.5095 33.7708 51.495 33.4961C51.4853 33.3064 51.421 32.96 51.362 32.7792C51.2765 32.5178 51.1729 32.3342 50.9658 31.9667L43.1852 18.1667L35.4047 31.9667C35.2128 32.3072 35.1168 32.4775 35.0279 32.7733C34.9734 32.9553 34.9102 33.3919 34.9107 33.5817C34.9121 33.8906 34.9308 33.9719 34.9684 34.135C35.6783 37.2222 39.0871 40.3889 43.1852 40.3889Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.4ea9b0528601a01365268d4fb9912710.svg";
export { ForwardRef as ReactComponent };